module.exports = __webpack_public_path__ + "static/media/Emotes-Translucent.16d3aceb.png";